module.exports = __webpack_public_path__ + "img/service_track.ac01bcec.svg";